import React, { Component } from 'react';
import { Card, Input, Row, Col, Button, Popconfirm, message, Modal, Tag } from 'antd';
import Reorder, { reorder } from 'react-reorder';
import lodash from 'lodash';
import './index.css';
import EditGroupModal from './modals/edit-group';

import { _postUpdateLeafPage } from '../../services/index';

const { TextArea } = Input;
const confirm = Modal.confirm;

class Group extends Component {

  constructor(props) {
    super(props);

    this.state = {

      currentLeafPage: {
        kebabName: "",
        groups: [],
        active: false,
        description: ""
      },

      currentGroup: {},

      currentGroupIndex: 0,
      saved: true,
    }

    this.onEditModalClick = this.onEditModalClick.bind(this);
    this.onEditModalCancel = this.onEditModalCancel.bind(this);
    this.onGroupNameChange = this.onGroupNameChange.bind(this);
    this.onImageURLChange = this.onImageURLChange.bind(this);
    this.onGroupChange = this.onGroupChange.bind(this);
    this.updateGroup = this.updateGroup.bind(this);
    this.onAddFakeSubCategory = this.onAddFakeSubCategory.bind(this);
    this.updateSubCats = this.updateSubCats.bind(this);
    this.onLeafSave = this.onLeafSave.bind(this);
    this.onActivationClick = this.onActivationClick.bind(this);
    this.updateText = lodash.debounce(this.updateTextCall,1000)
  }
  
  componentDidMount() {

    let newLP = this.props.currentLeafPage;

    newLP.groups.sort(( a,b ) => {
      if (a.position < b.position)
        return -1;
      if (a.position > b.position)
        return 1;
      return 0;
    })

    this.setState({ 
      currentLeafPage: newLP,
    })
  }

  // componentWillUnmount() {
  //   this.onLeafSave();
  // }

  render() {

    // console.log(Array.isArray(this.state.currentGroup))
    // console.log(this.state.currentLeafPage)

    return (
      <div>
        <Card
          title={(
            <div style={{ width: '100%', paddingTop: 15 }}>
              <Row type="flex">
                <Col span={4}>
                  <Button onClick={() => this.onLeave()} icon="left">Leaf Pages</Button>
                </Col>
                {/* <Col offset={16} span={2}>
                  <Popconfirm
                    title="Delete this Leaf Page?"
                    placement="bottom"
                    onConfirm={this.onDeleteConfirm}
                  >
                    <Button type="danger">Delete</Button>
                  </Popconfirm>
                </Col> */}
                <Col offset={16} span={2}>
                  {/* <Popconfirm
                    title="Save this Leaf Page?"
                    placement="bottomRight"
                    onConfirm={this.onLeafSave}
                  >
                    <Button type="primary" size="large" disabled={this.state.saved}>Save</Button>
                  </Popconfirm> */}
                  <span style={{ marginLeft: 40 }}>Status: </span>
                </Col>
                <Col span={2}>
                  {this.state.currentLeafPage.active ? <Tag color="green">Active</Tag> : <Tag color="red">Deactive</Tag>}
                </Col>
              </Row>
              <Row type="flex" align="middle">
                
                <Col span={19}>
                  <Row type="flex" className="padding-15">
                    <Input 
                      value={this.state.currentLeafPage.leafName}
                      onChange={this.onLeafNameChange}
                      size="large" 
                      placeholder="Leaf Page Name" 
                      style={{ fontSize: 20, fontWeight: '500', width: '70%', marginLeft: 2, border: "1px solid white" }}
                    />
                  </Row>

                  <Row type="flex" className="padding-15">
                    <Input 
                      value={this.state.currentLeafPage.mobileName}
                      onChange={this.onMobileLeafNameChange}
                      size="large" 
                      placeholder="Mobile Leaf Name" 
                      style={{ fontSize: 20, fontWeight: '500',  width: '70%', marginLeft: 2, border: "1px solid white" }}
                    />
                  </Row>

                  <Row align="middle" type="flex" >
                    <Col span={16}>
                      <TextArea 
                        value={this.state.currentLeafPage.description}
                        onChange={this.onLeafDescChange} 
                        placeholder="Description" 
                        style={{  marginLeft: 2, marginRight: 10, border: "1px solid white" }}
                      />
                    </Col>
                    <Col span={2}>
                      <span style={{ marginLeft: 10, fontSize: 15, fontWeight: 'lighter' }}>{this.state.currentLeafPage.description.length}/160</span>
                    </Col>
                  </Row>
                  <Row type="flex" style={{ marginTop: 10 }}>
                    <Input 
                      value={this.state.currentLeafPage.imageURL}
                      size="large"
                      placeholder="Image URL"
                      onChange={this.onLeafImageURLChange}
                      style={{ fontSize: 15,  width: '70%', marginLeft: 2, border: "1px solid white" }}
                    />
                  </Row>

                  <Row type="flex" style={{ marginTop: 10 }}>
                    <Input 
                      value={this.state.currentLeafPage.mobileImageURL}
                      size="large"
                      placeholder="Mobile Image URL"
                      onChange={this.onLeafMobileImageURLChange}
                      style={{ fontSize: 15,  width: '70%', marginLeft: 2, border: "1px solid white" }}
                    />
                  </Row>
                  
                  <Row type="flex" style={{ marginTop: 10 }}>
                    <Input
                      value={this.state.currentLeafPage.link}
                      size="large"
                      placeholder="Custom Link"
                      onChange={this.onLeafCustomLinkChange}
                      style={{ fontSize: 15,  width: '70%', marginLeft: 2, border: "1px solid white" }}
                    />
                  </Row>
                </Col>
                <Col span={5}>
                  {this.state.currentLeafPage.industry?
                  <img src={this.state.currentLeafPage.imageURL} width={294}/>
                  :
                  <img src={this.state.currentLeafPage.imageURL} alt="Leaf Page" height={150}/>}
                </Col>
              </Row>

            </div>
          )}
        >
          <Row type="flex" align="middle" className="table-header">
            <Col span={3}>
              <span>Image</span>
            </Col>
            <Col span={6}>
              <span>Group Name</span>
            </Col>
            <Col span={3}>
              <span>Status</span>
            </Col>
            <Col span={3}>
              <span>Sub Cats</span>
            </Col>
            <Col span={4}>
              <span>Image Link</span>
            </Col>
            <Col span={2}>
              <span>Actions</span>
            </Col>
            <Col span={2}>
              <Button onClick={this.onAddFakeGroup} style={{ marginLeft: 20 }} icon="plus">Add Group</Button>
            </Col>
          </Row>
            <Reorder
              reorderId="groups"
              reorderGroup="group-page"
              component="div"
              draggedClassName="dragged-list-item"
              lock="horizontal"
              holdTime={200}
              // onReorder={this.props.onReorderGroup}
              onReorder={this.onGroupReorder}
              disabled={false}
            >
              {
                this.state.currentLeafPage.groups.map(( group, index ) => (
                  <Row key={index} type="flex" align="middle" className="group-page-item">
                    <Col span={3}>
                      <img 
                        src={group.imageURL} 
                        alt="group"
                        height={80}
                        width={80}
                      />
                    </Col>
                    <Col span={6}>
                      <Input 
                        placeholder="Group Name"
                        value={group.name}
                        style={{ width: '90%', border: 'none' }}
                        onChange={(e) => this.onGroupNameChange(e, index)}
                      />

                      <Input 
                        placeholder="Mobile Group Name"
                        value={group.mobileName}
                        style={{ width: '90%', border: 'none' }}
                        onChange={(e) => this.onMobileGroupNameChange(e, index)}
                      />
                    </Col>
                    <Col span={3}>
                      {group.active ? <Tag color="green">Active</Tag> : <Tag color="red">Deactive</Tag>}
                    </Col>
                    <Col span={3}>
                      <span>{group.subCategories.length}</span>
                    </Col>
                    <Col span={3}>
                      <Input 
                        onChange={(e) => this.onImageURLChange(e, index)} 
                        value={group.imageURL} 
                        placeholder="Image URL"
                        style={{ border: 'none' }}
                      />
                      <Input 
                        onChange={(e) => this.onMobileImageURLChange(e, index)} 
                        value={group.mobileImageURL} 
                        placeholder="Mobile Image URL"
                        style={{ border: 'none' }}
                      />
                    </Col>
                    <Col span={5} offset={1}>
                      <Input.Group compact>
                        <Button
                          onClick={() => this.onEditModalClick(index)}
                        >Edit</Button>
                        <Popconfirm
                          title="Delete this group?"
                          placement="bottom"
                          okText="No"
                          cancelText="Delete"
                          onCancel={() => this.onDeleteConfirm(index)}
                        >
                          <Button type="danger">Delete</Button>
                        </Popconfirm>
                        <Popconfirm
                          title={group.active ? "Deactivate Group?" : "Activate Group?"}
                          okText="No"
                          cancelText="Yes"
                          onCancel={() => this.onActivationClick(index, group.active)}
                        >
                          <Button type="primary">{group.active ? <span>Deactivate</span> : <span>Activate</span>}</Button>
                        </Popconfirm>
                      </Input.Group>
                    </Col>
                    
                  </Row>
                ))
              }
            </Reorder>
        </Card>

      { this.state.editModalVisible && 
        <EditGroupModal 
          currentLeafPage={this.state.currentLeafPage}
          currentGroup={this.state.currentLeafPage.groups[this.state.currentGroupIndex]}
          currentGroupIndex={this.state.currentGroupIndex}
          onGroupNameChange={this.onGroupNameChange}
          onMobileGroupNameChange={ this.onMobileGroupNameChange }
          onImageURLChange={this.onImageURLChange}
          onMobileImageURLChange={this.onMobileImageURLChange}
          onGroupChange={this.onGroupChange}
          updateGroup={this.updateGroup}
          updateData={this.props.updateData}
          visible={this.state.editModalVisible}
          onCancel={this.onEditModalCancel}
          onAddFakeSubCategory={this.onAddFakeSubCategory}
          updateSubCats={this.updateSubCats}
          onLeafSave={this.onLeafSave}
        />
      }
      </div>
    );
  }

  onLeafCustomLinkChange = (e) => {
    e.persist();
    if (!this.state.currentLeafPage.active) {

      let newLeaf = this.state.currentLeafPage;

      newLeaf.link = e.target.value;

      this.setState({
        currentLeafPage: newLeaf,
        saved: false,
      }, this.updateText);

      
    } else {
      message.error('Please deactivate before making changes!')
    }
  }

  onLeafImageURLChange = (e) => {
    e.persist();
    if (!this.state.currentLeafPage.active) {

      let newLeaf = this.state.currentLeafPage;

      newLeaf.imageURL = e.target.value;

      this.setState({
        currentLeafPage: newLeaf,
        saved: false,
      }, this.updateText);

    } else {
      message.error('Please deactivate before making changes!')
    }
  }

  onLeafMobileImageURLChange = (e) => {
    e.persist();
    if (!this.state.currentLeafPage.active) {

      let newLeaf = this.state.currentLeafPage;

      newLeaf.mobileImageURL = e.target.value;

      this.setState({
        currentLeafPage: newLeaf,
        saved: false,
      }, this.updateText);

    } else {
      message.error('Please deactivate before making changes!')
    }
  }

  onLeafNameChange = (e) => {
    e.persist();
    if (!this.state.currentLeafPage.active) {

      let newLeaf = this.state.currentLeafPage;

      newLeaf.leafName = e.target.value;

      this.setState({
        currentLeafPage: newLeaf,
        saved: false,
      }, this.updateText);

    } else {
      message.error('Please deactivate before making changes!')
    }
  }

  onLeafDescChange = (e) => {
    e.persist();
    if (!this.state.currentLeafPage.active) {

      let newLeaf = this.state.currentLeafPage;

      newLeaf.description = e.target.value;

      this.setState({
        currentLeafPage: newLeaf,
        saved: false,
      }, this.updateText);

    } else {
      message.error('Please deactivate before making changes!')
    }
    
  }

  onMobileLeafNameChange = ( e ) => {
    e.persist();
    if (!this.state.currentLeafPage.active) {

      let newLeaf = this.state.currentLeafPage;

      newLeaf.mobileName = e.target.value;

      this.setState({
        currentLeafPage: newLeaf,
        saved: false,
      }, this.updateText);

    } else {
      message.error('Please deactivate before making changes!')
    }
  }

  onGroupReorder = ( event, previousIndex, nextIndex, fromId, toId ) => {
    let newGroups = reorder(this.state.currentLeafPage.groups, previousIndex, nextIndex);
    
    newGroups.map(( group, index ) => {
      group.position = index;

      return group;
    })

    let newLeaf = this.state.currentLeafPage;
    newLeaf.groups = newGroups;

    this.setState( prevState => ({
      currentLeafPage: {
        ...prevState.currentLeafPage,
        groups: newGroups,
      },
      saved: false
    }))

    _postUpdateLeafPage( newLeaf )
      .then(res => {
        this.props.updateData();
        message.success('Groups reordered!', 2);
      })
      .catch(err => {
        message.error('Groups reordering failed.', 2);
        console.log(err);
      })
  }

  onGroupNameChange = (e, index) => {
    e.persist();

    let newLeaf = this.state.currentLeafPage;

    if (!newLeaf.groups[index].active) {
      newLeaf.groups[index].name = e.target.value;
      newLeaf.groups[index].kebabName = lodash.kebabCase(e.target.value)
      this.setState({ 
        currentLeafPage: newLeaf,
        saved: false,
      }, this.updateText);

    } else {
      message.error('Please deactivate before making changes!');
    }
  }

  onMobileGroupNameChange = (e, index) => {
    e.persist();

    // let newLeaf = this.state.currentLeafPage;
    const { currentLeafPage } = this.state;

    if (!currentLeafPage.groups[index].active) {

      this.setState({
        currentLeafPage: {
          ...currentLeafPage,
          groups: currentLeafPage.groups.map(
            ( _group, _index ) => {

              if( index !== _index ){

                return _group;
                
              }

              return {
                ..._group,
                mobileName: e.target.value
              }

            }
          )
        },
        saved: false,
      }, this.updateText);
      

    } else {
      message.error('Please deactivate before making changes!');
    }

  }

  onImageURLChange = (e, index) => {
    e.persist();

    let newLeaf = this.state.currentLeafPage;

    if (!newLeaf.groups[index].active) {
      newLeaf.groups[index].imageURL = e.target.value;
      this.setState({ 
        currentLeafPage: newLeaf,
        saved: false,
      }, this.updateText) ;

    } else {
      message.error('Please deactivate before making changes!');
    }
  }

  onMobileImageURLChange = (e, index) => {
    e.persist();

    let newLeaf = this.state.currentLeafPage;

    if (!newLeaf.groups[index].active) {
      newLeaf.groups[index].mobileImageURL = e.target.value;
      this.setState({ 
        currentLeafPage: newLeaf,
        saved: false,
      }, this.updateText) ;

    } else {
      message.error('Please deactivate before making changes!');
    }
  }

  updateTextCall = () => {

    const { currentLeafPage } = this.state;

    _postUpdateLeafPage( currentLeafPage )
      .then(res => {
        this.props.updateData();

        message.success("Updated Text!");
      })
      .catch(err => {
        console.log(err);
      })
  }



  onAddFakeGroup = () => {
    let newLeaf = this.state.currentLeafPage;

    if (newLeaf.groups.length >= 5) {
      message.error('Cannot add more than 5 groups!', 3);
    } else {
      newLeaf.groups.push({
        name: "",
        kebabName: "",
        imageURL: "",
        position: newLeaf.groups.length,
        subCategories: []
      });
  
      this.setState({
        currentLeafPage: newLeaf,
        saved: false,
      });
    }

  }

  onAddFakeSubCategory = () => {
    let newLeaf = this.state.currentLeafPage;
    const currentGroupIndex = this.state.currentGroupIndex;

    newLeaf.groups[currentGroupIndex].subCategories.push({
      name: "",
      kebabName: "",
      imageURL: "",
      position: this.state.currentGroup.subCategories.length
    });

    this.setState({
      currentLeafPage: newLeaf,
      currentGroup: newLeaf.groups[this.state.currentGroupIndex]
    })

    message.success('Choose Sub Category to save!')
  }

  onEditModalClick = (index) => {
    this.setState({
      editModalVisible: true,
      currentGroupIndex: index,
      currentGroup: this.state.currentLeafPage.groups[index]
    })

  }

  onEditModalCancel = () => {
    this.setState({
      editModalVisible: false,
      currentGroupIndex: 0
    })
  }

  onDeleteConfirm = ( index ) => {
    let newLeaf = this.state.currentLeafPage;

    if (newLeaf.groups[index].subCategories.length === 0) {
      newLeaf.groups.splice( index, 1 );

      this.setState({
        currentLeafPage: newLeaf,
        saved: false,
      })

      _postUpdateLeafPage( newLeaf )
        .then(res => {
          this.props.updateData();
          message.success("Group has been deleted")
        })
        .catch(err => console.error(err));

    } else {
      message.error("There are still existing Sub Categories in this Group!", 3)
    }

    
  }

  onLeafSave = () => {
    _postUpdateLeafPage( this.state.currentLeafPage )
      .then(res => {
        // console.log(res.data);
        this.props.updateData();
        this.setState({
          saved: true
        });
      })
      .catch(err => { 
        console.error(err)
        message.error("Failed to save Leaf Page!")
      });
  }

  leaveWithoutSaving = () => {
    this.props.onPageChange('leaf-pages')
  }

  onLeave = () => {
    this.props.onPageChange('leaf-pages');
  }

  onGroupChange = () => {
    this.setState({
      saved: false,
    })

    this.onLeafSave();
  }

  updateGroup = (newgroup, index) => {
    let newLeaf = this.state.currentLeafPage;

    newLeaf.groups[index] = newgroup;

    this.setState({
      currentLeafPage: newLeaf
    })
  }

  updateSubCats = (newSubCats) => {
    this.setState(prevState => ({
      currentGroup: {
        ...prevState.currentGroup,
        subCategories: newSubCats
      }
    }))
  }

  onActivationClick = (groupIndex, activation) => {
    
    let currentGroup = this.state.currentLeafPage.groups[groupIndex];

    console.log(!activation)

    if (!activation) {

      if (currentGroup.name.length > 0 && currentGroup.imageURL.length > 0) {
        if (this.checkSubCatsActivations(groupIndex)) {
          let newLeaf = this.props.currentLeafPage;
      
          newLeaf.groups[groupIndex].active = !this.props.currentLeafPage.groups[groupIndex].active;
      
          _postUpdateLeafPage( newLeaf )
          .then(res => {
            // this.props.updateData();
            // console.log(res.data.updated);
            this.props.updateCurrentLeafPage(res.data.updated);
            this.setState({
              currentLeafPage: res.data.updated
            });
            message.warning('Group status switched!');
          })
          .catch(err => console.error(err));
        } else {
          message.error('Make sure at least one Sub Category is Active before activating this Group.')
        }
      } else {
        message.error('Please fill in required name and image.')
      }
    } else {
      this.checkGroupActivations(this.props.currentLeafPage, groupIndex);
    }
    

    
  }

  checkGroupActivations = ( leafPage, groupIndex ) => {
    let result = 0;

    leafPage.groups.map( group => {
      if (group.active) {
        result++;
      }

      return group;
    })

    console.log(result)

    if (result === 1) {
      let newLeaf = this.props.currentLeafPage;
      

      confirm({
        title: 'Deactivating this will cause the parent Leaf Page to deactivate!',
        content: <div>
          <p>This is to prevent users from entering an empty Leaf Page. Once you've done your changes, reactivate these again:</p>
          <br/>
          <p>Leaf Page: "{leafPage.leafName}"</p>
        </div>,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
      
          newLeaf.groups[groupIndex].active = !newLeaf.groups[groupIndex].active;
          newLeaf.active = false;
      
          _postUpdateLeafPage( newLeaf )
          .then(res => {
            // this.props.updateData();
            console.log(res.data.updated);
            this.props.updateCurrentLeafPage(res.data.updated);
            this.setState({
              currentLeafPage: res.data.updated
            });
            message.warning('Leaf Page & Group status switched!');
          })
          .catch(err => console.error(err));
        }
      })
    } else {
      let newLeaf = this.props.currentLeafPage;

      newLeaf.groups[groupIndex].active = !this.props.currentLeafPage.groups[groupIndex].active;
  
      _postUpdateLeafPage( newLeaf )
      .then(res => {
        // this.props.updateData();
        console.log(res.data.updated);
        this.props.updateCurrentLeafPage(res.data.updated);
        this.setState({
          currentLeafPage: res.data.updated
        });
        message.warning('Group status switched!');
      })
      .catch(err => console.error(err));
    }
  }

  checkSubCatsActivations = ( groupIndex ) => {

    let result = false;
    let subCategories = this.state.currentLeafPage.groups[groupIndex].subCategories;

    // console.log(this.state.currentLeafPage.groups[groupIndex].subCategories)
    for (let i = 0; i < subCategories.length; i++) {
      if (subCategories[i].active) {
        result = true;
      }
    }
    return result;
  }

} 

export default Group;


// WEBPACK FOOTER //
// ./src/components/leaf-page/group-page.js